module.exports = __webpack_public_path__ + "static/img/honor21.34038ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/honor/honor21.png
// module id = ef3Q
// module chunks = 0